import React, { useRef, useEffect } from 'react';
import _ from 'lodash'

import { areAnglesWithin } from '../are_angles_within.js'
import matrixAnimationEffect from './matrix_animation_effect.js'

import MemoizedKey from './MemoizedKey.jsx'

// TODO: unique ids and omit container
const OptionKeys = ({ keys, overed })=>{
	const option_keys = useRef()

	useEffect(() =>{
		if(!overed){
			return matrixAnimationEffect(keys, option_keys.current, Math.random()*20)
		}
	}, [overed, keys])

	const flatten_keys = keys.flat().map((key, key_index) => {
		return (
			<MemoizedKey
				{...key}
				key={'key-' + key_index}
				className={'key-' + key_index}
				overed={overed}
			/>
		)
	})

	return (<div ref={option_keys}>
		{flatten_keys}
	</div>)
}

export default React.memo(OptionKeys)